import React, { useState } from "react";
import { Plus } from "lucide-react";
import { MOCK_WALLET } from "../../data/mock";
import UPIPaymentModal from "../../components/shared/UPIPaymentModal";

export default function CustomerWallet() {
  const [show, setShow] = useState(false);
  const [amount, setAmount] = useState(500);

  return (
    <div data-testid="customer-wallet">
      <h1 className="font-display text-3xl font-bold">Wallet</h1>

      <div className="mt-4 overflow-hidden rounded-lg border border-neutral-200 bg-neutral-950 p-6 text-white grain">
        <div className="text-xs font-semibold uppercase tracking-widest text-lime-400">Available balance</div>
        <div className="mt-1 font-display text-5xl font-black">₹{MOCK_WALLET.balance.toLocaleString("en-IN")}</div>
        <div className="mt-4 flex flex-wrap gap-2">
          {[100, 200, 500, 1000, 2000].map((a) => (
            <button key={a} onClick={() => setAmount(a)} className={`rounded-full border px-3 py-1 text-xs font-bold ${amount === a ? "border-lime-400 bg-lime-400 text-neutral-950" : "border-white/30 text-white hover:border-lime-400"}`} data-testid={`wallet-chip-${a}`}>₹{a}</button>
          ))}
          <button onClick={() => setShow(true)} className="btn-offset ml-auto inline-flex items-center gap-1 rounded-md bg-lime-400 px-4 py-2 text-xs font-bold text-neutral-950 hover:bg-lime-300" data-testid="wallet-topup"><Plus size={14} /> Top up ₹{amount}</button>
        </div>
      </div>

      <div className="mt-6 rounded-lg border border-neutral-200 bg-white">
        <div className="border-b border-neutral-200 px-5 py-3 text-xs font-semibold uppercase tracking-widest text-neutral-500">Transactions</div>
        <ul className="divide-y divide-neutral-100">
          {MOCK_WALLET.transactions.map((t) => (
            <li key={t.id} className="flex items-center justify-between px-5 py-3" data-testid={`wallet-tx-${t.id}`}>
              <div>
                <div className="text-sm font-semibold">{t.desc}</div>
                <div className="text-xs text-neutral-500">{t.at} · {t.id}</div>
              </div>
              <div className={`font-mono font-bold ${t.amount > 0 ? "text-lime-600" : "text-neutral-900"}`}>{t.amount > 0 ? "+" : ""}₹{Math.abs(t.amount).toLocaleString("en-IN")}</div>
            </li>
          ))}
        </ul>
      </div>

      <UPIPaymentModal open={show} onClose={() => setShow(false)} amount={amount} orderRef="Wallet top-up" />
    </div>
  );
}
